import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import WalletList from "../SignInUp/components/walletList";
import { COMMON_WEB_PATH, CURRENCY_SYMBOL } from "../../constant";
import { IoIosAdd } from "react-icons/io";
import MyBalanceV3 from "./BalanceContent";
import { useLocation } from "react-router";
import { Box, Flex, useColorModeValue, useDisclosure } from "@chakra-ui/react";
import useCheckLogin from "../../hook/useCheckLogin";
import useIsLandScapeMachine from "../../hook/useIsLandScapeMachine";

const isCredit = process.env.REACT_APP_CREDIT == 1;
const Balance = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { isMachineUser } = useCheckLogin();

  const linkColor = useColorModeValue("light.100", "#394367");

  const memberInfo = useSelector((state) => state.isMemberInfo);

  const { pathname } = useLocation();

  const isLandScapeMachine = useIsLandScapeMachine();

  return (
    <Flex
      borderRadius={`10px`}
      bgImage={{
        base: `url('${COMMON_WEB_PATH}/now888/header/point_banner.png')`,
        md: `url('${COMMON_WEB_PATH}/now888/header/point_banner.png')`,
      }}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100%100%"
      pl={{
        base: "30px",
        md: isMachineUser ? "70px" : "55px",
      }}
      pr={{
        base: "10px",
        md: "40px",
      }}
      pb={{
        base: "0px",
        md: "0px",
      }}
      alignItems="center"
      gap="10px"
      minW={{
        base: "100px",
        //md: "180px",
        md: isMachineUser ? "245px" : "180px",
      }}
      maxW={{
        base: "118px",
        md: "250px",
        xl: "300px",
      }}
      height={{
        base: "35px",
        md: isMachineUser ? "60px" : "55px",
        //xl: "90px",
        xl: isMachineUser ? "60px" : "55px",
      }}
      cursor="pointer"
      position="relative"
      // mb={{
      //   sm: "10px",
      // }}
      shadow="sm"
      justifyContent={"center"}
    >
      <Flex w="100%" direction={`column`} alignItems={`center`}>
        <Box
          onClick={() => {
            if (pathname.includes("gamebox")) {
              return;
            } else {
              if (isCredit) {
                return;
              }
              onToggle();
            }
          }}
          display={`flex`}
          alignItems={`center`}
          w="100%"
          gap="5px"
          overflowX="scroll"
          mb={
            isLandScapeMachine
              ? 0
              : {
                  base: "5px",
                  md: "10px",
                }
          }
        >
          <MyBalanceV3
            // hiddenSymbol
            hiddenSymbol
            balanceStyle={{
              fontSize: {
                base: "13px",
                md: "30px",
                lg: "34px",
                xl: isMachineUser ? "47px" : "35px",
              },
              fontWeight: "900",
            }}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default Balance;
